/// <summary>
/// 统计分析的追踪对象
/// </summary>
/// <author>xiexingwu</author>
import KitAPI from "../KitAPI";
import {CacheManager} from "./CacheManager";
import {JsonData} from "@/Fwk/Kit/JsonData";
import {RecodeKey} from "@/Fwk/Kit/Track/TrackConst";
import Util from "@/Master/Util";
import KitLog from "@/Fwk/Kit/KitLog";
import {KitTrack} from "@/Fwk/Kit/Track/KitTrack";

export class KitEvent extends JsonData {
    private EbKey1 = "eb_key1";
    private EbKey2 = "eb_key2";

    private EVENT = "event"; // 事件名称
    private SRC = "src"; // 协议号
    private TIME_STAMP = "time_stamp"; // 时间戳

    public _src: number;
    public _name: string = "";
    private isSubmitted = false;

    constructor(src: number, name: string) {
        super();
        this._src = src;
        this._name = name;
    }

    /// <summary>
    /// 添加统计字段
    /// </summary>
    /// <param name="key">key</param>
    /// <param name="value">值</param>
    /// <returns></returns>
    public Put(key: string, value: number | string | boolean): KitEvent {
        if (key && value) {
            this.jObject[key] = value;
        }
        return this;
    }

    /// <summary>
    /// 添加统计
    /// </summary>
    /// <param name="keyValues">键值对列表</param>
    /// <returns>该事件对象</returns>
    public PutMap(keyValues: Map<string, string>): KitEvent {
        if (keyValues != null && keyValues.size > 0) {
            keyValues.forEach((item,key)=>{
                const v = item ?? "";
                this.Put(key, v);
            })
        }
        return this;
    }

    /// <summary>
    /// 添加统计参数1、参数2
    /// </summary>
    /// <param name="value1">参数1</param>
    /// <param name="value2">参数2</param>
    /// <returns>该事件对象</returns>
    public Put12(value1: number | string | boolean, value2: number | string | boolean): KitEvent {
        if (value1 != null) {
            this.Put(this.EbKey1, value1);
        }

        if (value2 != null)
            this.Put(this.EbKey2, value2);
        return this;
    }


    /// <summary>
    /// 添加统计字段参数1
    /// </summary>
    /// <param name="value">参数1</param>
    /// <returns>该事件对象</returns>
    public Put1(value: number | string | boolean): KitEvent {
        this.Put(this.EbKey1, value);
        return this;
    }

    public Put2(value: number | string | boolean): KitEvent {
        this.Put(this.EbKey2, value);
        return this;
    }

    /// <summary>
    /// 事件提交
    /// </summary>
    public Commit() {
        if (this.isSubmitted) return;
        this.isSubmitted = true;
        this.put(this.EVENT, this._name);
        this.put(this.SRC, this._src);
        this.put(this.TIME_STAMP, KitAPI.GetNowMills());
        //是否为升级用户
        this.put(RecodeKey.IS_UPGRADE_USER, KitAPI.isUpdateUser ? 1 : 0);
        //用户账号
        this.put(RecodeKey.CUSTOM_USER_ID, KitAPI.userId);
        //versionName
        this.put(RecodeKey.VERSION_NAME, KitAPI.versionName);
        //versionCode
        this.put(RecodeKey.VERSION_CODE, KitAPI.versionCode);
        //安装天数
        this.put(RecodeKey.INSTALL_DAYS, KitAPI.GetActiveDay());
        //安装小时
        this.put(RecodeKey.INSTALL_HOURS, KitAPI.GetActiveHours());
        //网络状态
        this.put(RecodeKey.NET, KitAPI.GetNetworkType());
        this.put(RecodeKey.VPN_USR, KitAPI.isVpnConnected() ? 1 : 0);
        // this.put(RecodeKey.MEMORY, MemoryHelper.getTotalMemory()/1024)
        // this.put(RecodeKey.USR_ABS, KitAB.getAbExperimentData()?.ToString() ?? "");
        CacheManager.submit(this);

        // if (KitLog.IsLog){
        //     console.log(`SDK track 事件提交=`,this._name,this);
        // }
    }

    public static track(src: number, name: string): KitEvent {
        return new KitEvent(src, name);
    }

    public static track113(name: string): KitEvent {
        return new KitEvent(113, name);
    }

    public static track112(name: string): KitEvent {
        return new KitEvent(112, name);
    }

    public static track511(name: string): KitEvent {
        return new KitEvent(511, name);
    }

    public static track512(name: string): KitEvent {
        return new KitEvent(512, name);
    }

    public static track513(name: string): KitEvent {
        return new KitEvent(513, name);
    }

    public static track217(name: string): KitEvent {
        return new KitEvent(217, name);
    }
}